import React from "react";
import Navbar from "../../Navbar/Navbar";
import MobileNavbar from "../../MobileNavbar/MobileNavbar";
import styles from "./hero.module.scss";
import { Link } from "react-router-dom";
// import { FaAngleRight } from "react-icons/fa";
// import { GrLinkNext } from "react-icons/gr";
import { GrFormNextLink } from "react-icons/gr";
import img from '../../../assets/support.jpg'

const Hero = () => {
  return (
    <section className={styles.hero_mainContainer} style={{backgroundImage: `url(${img})`}}>
      <Navbar />
      <MobileNavbar />

      <div className={styles.hero_container} >
        <div className={styles.hero_content_container}>
          <div>
            <h1 className={styles.hero_heading}>MILLENSYS support</h1>
            <h1 className={styles.hero_heading}>we are here to help</h1>
          </div>

          <div className={styles.links_container}>
            <Link to='/contact' className={styles.links_container__link}>
            Request a remote support <GrFormNextLink className={styles.__rightarrow} />
            </Link>

            <Link to='/contact' className={styles.links_container__link}>
            Report a Bug or ask for a feature
              <GrFormNextLink className={styles.__rightarrow} />
            </Link>

            <Link to='/order' className={styles.links_container__link}>
            Request/Renew service agreement
              <GrFormNextLink className={styles.__rightarrow} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
